import type { PermissionStructureGroup } from "@/services/role_permission";

const groupNameKeyMap: Record<string, string> = {
  Products: "products",
  Sales: "sales",
  Purchases: "purchases",
  Quotations: "quotations",
  Adjustments: "adjustments",
  Transfers: "transfers",
  "Customers & Suppliers": "customers_suppliers",
  Expenses: "expenses",
  Coupons: "coupons",
  "Membership Cards": "membership_cards",
  Promotions: "promotions",
  "User Management": "user_management",
  Settings: "settings",
  Reports: "reports",
};

type TranslateFn = (key: string, params?: Record<string, unknown>) => string;
type ExistsFn = (key: string) => boolean;

const translateWithFallback = (
  key: string,
  fallback: string,
  t: TranslateFn,
  te: ExistsFn,
) => (te(key) ? t(key) : fallback);

export const localizePermissionStructure = (
  groups: PermissionStructureGroup[],
  t: TranslateFn,
  te: ExistsFn,
) =>
  groups.map((group) => ({
    ...group,
    name: translateWithFallback(
      `group_permission_page.groups.${groupNameKeyMap[group.name] || group.name}`,
      group.name,
      t,
      te,
    ),
    permissions: group.permissions.map((perm) => ({
      ...perm,
      label: translateWithFallback(
        `group_permission_page.permissions.${perm.key}`,
        perm.label,
        t,
        te,
      ),
    })),
  }));
